import { useState } from 'react';
import type { Company } from '../lib/types';

type Props = { companies: Company[] };

export function Ventures({ companies }: Props) {
  return (
    <section
      id="section-ventures"
      className="section"
      style={{ padding: '48px 28px' }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          marginBottom: 20,
        }}
      >
        <div className="eyebrow">§ 02 · Known ventures · n={companies.length}</div>
        <div
          style={{
            fontSize: 10,
            opacity: 0.5,
            letterSpacing: 1,
            textTransform: 'uppercase',
          }}
        >
          hover to inspect
        </div>
      </div>
      <div style={{ borderTop: '1px solid var(--ink)' }}>
        {companies.map((c, i) => (
          <VentureRow key={`${c.name}-${c.year}`} company={c} index={i} />
        ))}
      </div>
    </section>
  );
}

function VentureRow({ company: c, index: i }: { company: Company; index: number }) {
  const [hover, setHover] = useState(false);

  const inverted = hover;
  const color = inverted ? 'var(--paper)' : 'var(--ink)';
  const nameColor = inverted ? 'var(--accent-warm)' : 'var(--ink)';

  return (
    <div
      className="vent-row"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'grid',
        gridTemplateColumns: '60px 2fr 3fr 2fr 1fr',
        padding: '14px 0',
        paddingLeft: hover ? 14 : 0,
        borderBottom: '1px solid var(--ink)',
        alignItems: 'baseline',
        cursor: 'pointer',
        background: hover ? 'var(--ink)' : 'transparent',
        color,
        transition: 'background 0.14s, padding-left 0.18s, color 0.14s',
      }}
    >
      <div style={{ opacity: 0.5 }}>#{String(i + 1).padStart(2, '0')}</div>
      <div
        className="serif vent-name"
        style={{
          fontSize: 26,
          lineHeight: 1,
          fontStyle: hover ? 'italic' : 'normal',
          color: nameColor,
        }}
      >
        {c.name}
      </div>
      <div className="vent-role" style={{ fontSize: 12.5, opacity: inverted ? 0.86 : 0.78 }}>
        {c.role}
      </div>
      <div
        className="vent-exit"
        style={{
          fontSize: 10.5,
          textTransform: 'uppercase',
          letterSpacing: 0.7,
          opacity: inverted ? 0.82 : 0.7,
        }}
      >
        {c.exit || '— active —'}
      </div>
      <div className="vent-year tabular" style={{ textAlign: 'right' }}>
        {c.year}
      </div>
    </div>
  );
}
